import React, { } from 'react';
import { Navigate } from 'react-router-dom';


export  const MainRoutes=[
      {
            path:'/login',
            lazyComponent:()=>import('./login/LoginPage')
      },
      {
            path:'/d',
            lazyComponent:()=>import('./dataV/index'),
      },
      {
            path:'/d2/:id',
            lazyComponent:()=>import('./dataV/DataVPage'),
      },
      {
            path:'/d2/:id/stats',
            lazyComponent:()=>import('./dataV/StatsPage'),
      },
      {
            path:'/',
            lazyComponent:()=>import('./main/MainPage'),
            root:true,
            children:[
                  {
                        path:'/',
                        component:<Navigate to="/home" replace />,
                  },
                  {
                        path:'/home',
                        lazyComponent:()=>import('./home/HomePage'),
                  },
                  {
                        path:'/user/me',
                        lazyComponent:()=>import('./user/UserMePage'),
                  },
                  {
                        path:'/sys/menus',
                        lazyComponent:()=>import('./sys/MenusPage'),
                  },
                  {
                        path:'/sys/list',
                        lazyComponent:()=>import('./sys/SysListPage'),
                  },
                  {
                        path:'/org/roles',
                        lazyComponent:()=>import('./org/RoleListPage'),
                  },
                  {
                        path:'/org/accounts',
                        lazyComponent:()=>import('./org/AccountListPage'),
                  },
                  {
                        path:'/org/members',
                        lazyComponent:()=>import('./org/MemberListPage'),
                  },
                   {
                        path:'/iot/product/categorys',
                        lazyComponent:()=>import('./iot/IotProductCategoryListPage'),
                  },
                  {
                        path:'/iot/product/list',
                        lazyComponent:()=>import('./iot/IotProductListPage'),
                  },
                  {
                        path:'/iot/device/list',
                        lazyComponent:()=>import('./iot/IotDeviceListPage'),
                  },
                  {
                        path:'/iot/device/media/list',
                        lazyComponent:()=>import('./iot/IotCameraVideoListPage'),
                  },
                  {
                        path:'/iot/model/list',
                        lazyComponent:()=>import('./iot/IotThingsModelListPage'),
                  },
                  {
                        path:'/trace/product/categorys',
                        lazyComponent:()=>import('./trace/TraceProductCategoryListPage'),
                  },
                  {
                        path:'/trace/product/list',
                        lazyComponent:()=>import('./trace/TraceProductListPage'),
                  },
                  {
                        path:'/trace/product/batch/list',
                        lazyComponent:()=>import('./trace/TraceProductBatchListPage'),
                  },
                  {
                        path:'/trace/code/list',
                        lazyComponent:()=>import('./trace/TraceCodeListPage'),
                  },
                  {
                        path:'/trace/code/info',
                        lazyComponent:()=>import('./trace/TraceCodeInfoPage'),
                  },
                  {
                        path:'/trace/inspection/types',
                        lazyComponent:()=>import('./trace/TraceInspectionTypeListPage'),
                  },
                  {
                        path:'/trace/inspection/record/list',
                        lazyComponent:()=>import('./trace/TraceInspectionListPage'),
                  },
                  {
                        path:'/trace/quality/standards',
                        lazyComponent:()=>import('./trace/TraceQualityStandardListPage'),
                  },
                  {
                        path:'/trace/quality/groups',
                        props:{type:'TraceQualityStandardGroup'},
                        lazyComponent:()=>import('./data/CategoryListPage'),
                  },
                  {
                        path:'/trace/storageconditions',
                        lazyComponent:()=>import('./trace/TraceStorageConditionListPage'),
                  },
                  {
                        path:'/trace/shop/list',
                        lazyComponent:()=>import('./trace/TraceShopListPage'),
                  },
                  {
                        path:'/farm/list',
                        lazyComponent:()=>import('./farm/FarmListPage'),
                  },
                  {
                        path:'/farm/cert/list',
                        lazyComponent:()=>import('./farm/FarmCertListPage'),
                  },
                  {
                        path:'/farm/batch/list',
                        lazyComponent:()=>import('./farm/FarmProductBatchListPage'),
                  },
                  {
                        path:'/farm/plot/list',
                        lazyComponent:()=>import('./farm/FarmPlotListPage'),
                  },
                  {
                        path:'/farm/task/list',
                        lazyComponent:()=>import('./farm/FarmTaskListPage'),
                  },
                  {
                        path:'/farm/material/type/list',
                        lazyComponent:()=>import('./farm/FarmMaterialTypeListPage'),
                  },
                  {
                        path:'/farm/material/list',
                        lazyComponent:()=>import('./farm/FarmMaterialListPage'),
                  },
                  {
                        path:'/farm/product/list',
                        lazyComponent:()=>import('./farm/FarmProductListPage'),
                  },
                  {
                        path:'/farm/ser/list',
                        lazyComponent:()=>import('./farm_ser/FarmSerListPage'),
                  },
                  {
                        path:'/qrcode/list',
                        lazyComponent:()=>import('./qrcode/CodeListPage'),
                  },
                  {
                        path:'/qrcode/batch/list',
                        lazyComponent:()=>import('./qrcode/CodeBatchListPage'),
                  },
                  {
                        path:'/code/list',
                        lazyComponent:()=>import('./code/CodeListPage'),
                  },
                  {
                        path:'/code/batch/list',
                        lazyComponent:()=>import('./code/CodeBatchListPage'),
                  },
                  {
                        path:'/portal/article/category/list',
                        lazyComponent:()=>import('./portal/ArticleCategoryListPage'),
                  },
                  {
                        path:'/portal/article/list',
                        lazyComponent:()=>import('./portal/ArticleListPage'),
                  },
                  {
                        path:'/portal/article/edit',
                        lazyComponent:()=>import('./portal/ArticleEditPage'),
                  },
            ]
      },
];


